import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/notification-preferences")({
    beforeLoad: () => {
        throw redirect({ to: "/users/patients", replace: true });
    },
});
